<app-modal-component [open]="open" label="Edit send times">
  <div class="cf__dialog">
    <app-form-wrapper title="Edit send times" (iconClick)="close()" icon="cancel">
      <form [formGroup]="messageSchedule" (submit)="$event.preventDefault()">
        <div class="cf__body">
          <!-- message -->
          <div class="cf__fact">
            <span class="cf__fact-label">Message</span>
            <span class="cf__fact-value">{{ messageSubject }}</span>
          </div>

          <p class="cf__lead">Times must fall between the campaign dates ({{ campaignRange }}).</p>

          <ng-container formArrayName="messageDates">
            @for (control of messageDates.controls; track control; let i = $index) {
              <div class="cf__item cf__send" [formGroupName]="i">
                <div class="cf__row cf__row--3">
                  <!-- date -->
                  <input-field
                    [label]="$count > 1 ? 'Date ' + (i + 1) : 'Date'"
                    [errorMessage]="
                      control.get('date')?.errors?.['outOfRange'] && control.get('date')?.dirty
                        ? 'Pick a date between the campaign start and end.'
                        : control.get('date')?.errors?.['required'] && scheduleSubmitted
                          ? 'Choose a date.'
                          : ''
                    "
                  >
                    <input
                      type="date"
                      class="input-style"
                      formControlName="date"
                      [min]="campaignStart"
                      [max]="campaignEnd"
                      (change)="validateMessageDate(i)"
                      (change)="validateMessageTime(i)"
                    />
                  </input-field>

                  <!-- time -->
                  <input-field
                    [label]="$count > 1 ? 'Time ' + (i + 1) : 'Time'"
                    [errorMessage]="
                      control.get('time')?.errors?.['past']
                        ? 'That time has passed. Pick a later one.'
                        : control.get('time')?.errors?.['required'] && scheduleSubmitted
                          ? 'Choose a time.'
                          : ''
                    "
                  >
                    <input type="time" class="input-style" formControlName="time" (change)="validateMessageTime(i)" />
                  </input-field>

                  <!-- time zone -->
                  <input-field
                    [label]="$count > 1 ? 'Time zone ' + (i + 1) : 'Time zone'"
                    [errorMessage]="control.get('timezone')?.errors?.['required'] && scheduleSubmitted ? 'Choose a time zone.' : ''"
                  >
                    <select class="input-style" formControlName="timezone" (change)="validateMessageTime(i)">
                      <option value="" disabled>Choose a time zone</option>
                      @for (tz of timeZones; track $index) {
                        <option [value]="tz.timezone">{{ tz.timezone }}</option>
                      }
                    </select>
                  </input-field>
                </div>

                @if ($count > 1) {
                  <button
                    type="button"
                    class="bk-icon-btn cf__remove"
                    [attr.aria-label]="'Remove send time ' + (i + 1)"
                    matTooltip="Remove this time"
                    (click)="removeMessageDates(i)"
                  >
                    <span class="bk-sym" aria-hidden="true">close</span>
                  </button>
                }
              </div>
            }
          </ng-container>

          <button type="button" class="cf__add" (click)="addMessageDates()">
            <span class="bk-sym" aria-hidden="true">add</span>
            Add another time
          </button>
        </div>

        <!-- footer -->
        <div class="cf__foot">
          <button type="button" class="bk-btn bk-btn--ghost" (click)="close()">Cancel</button>
          <div class="cf__foot-end">
            <button type="button" class="bk-btn bk-btn--primary" (click)="saveSchedule()">Save send times</button>
          </div>
        </div>
      </form>
    </app-form-wrapper>
  </div>
</app-modal-component>
